/* __next_internal_client_entry_do_not_use__ useInsiderMembershipInformation auto */ import { InsiderMembershipMutated } from "@faire/retailer-visitor-shared/events";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { getInsiderMemershipInformation } from "@faire/retailer-visitor-shared/serialized-data/getInsiderMembershipInformation";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useQuery as useInsiderMembershipInformationQuery, useInvalidateQuery as useInsiderMembershipInformationInvalidateQuery } from "@faire/web-api--source/api/membership/retailerToken/get-hooks";
import { useEffect } from "react";
/** This hook fetches InsiderMembershipInformation */ export function useInsiderMembershipInformation() {
    var _insiderMembershipInformation_threshold_values, _insiderMembershipInformation_threshold_values1;
    var retailerToken = useRetailerStore([
        "retailerToken"
    ]).retailerToken;
    var isLoggedInRetailer = useIsLoggedInRetailer();
    //  serialized data is valid until it gets mutated. Hence, it will not become stale until it is invalidated
    var _useInsiderMembershipInformationQuery = useInsiderMembershipInformationQuery(retailerToken !== null && retailerToken !== void 0 ? retailerToken : "", {
        initialData: getInsiderMemershipInformation,
        staleTime: Infinity,
        enabled: !!retailerToken
    }), insiderMembershipInformation = _useInsiderMembershipInformationQuery.data, isInsiderMembershipInformationFetching = _useInsiderMembershipInformationQuery.isFetching, isInsiderMembershipInformationPending = _useInsiderMembershipInformationQuery.isPending;
    var invalidateInsiderMembershipInformationQuery = useInsiderMembershipInformationInvalidateQuery();
    useEffect(function() {
        var invalidationFn;
        if (isLoggedInRetailer && retailerToken) {
            invalidationFn = function() {
                return invalidateInsiderMembershipInformationQuery(retailerToken);
            };
            invalidateOnEvents(invalidationFn, retailerToken);
        }
        return function() {
            if (invalidationFn !== undefined) {
                invalidateAppEvents(invalidationFn);
            }
        };
    }, [
        retailerToken,
        isLoggedInRetailer,
        invalidateInsiderMembershipInformationQuery
    ]);
    var threshold1 = insiderMembershipInformation === null || insiderMembershipInformation === void 0 ? void 0 : (_insiderMembershipInformation_threshold_values = insiderMembershipInformation.threshold_values) === null || _insiderMembershipInformation_threshold_values === void 0 ? void 0 : _insiderMembershipInformation_threshold_values.THRESHOLD_1;
    var threshold2 = insiderMembershipInformation === null || insiderMembershipInformation === void 0 ? void 0 : (_insiderMembershipInformation_threshold_values1 = insiderMembershipInformation.threshold_values) === null || _insiderMembershipInformation_threshold_values1 === void 0 ? void 0 : _insiderMembershipInformation_threshold_values1.THRESHOLD_2;
    var _insiderMembershipInformation_threshold_values2;
    var thresholdCounts = Object.keys((_insiderMembershipInformation_threshold_values2 = insiderMembershipInformation === null || insiderMembershipInformation === void 0 ? void 0 : insiderMembershipInformation.threshold_values) !== null && _insiderMembershipInformation_threshold_values2 !== void 0 ? _insiderMembershipInformation_threshold_values2 : {}).length;
    return {
        insiderMembershipInformation: insiderMembershipInformation,
        isInsiderMembershipInformationFetching: isInsiderMembershipInformationFetching,
        isInsiderMembershipInformationPending: isInsiderMembershipInformationPending,
        thresholds: {
            threshold1: threshold1,
            threshold2: threshold2
        },
        thresholdCounts: thresholdCounts
    };
}
var invalidateAppEvents = function(invalidationFn) {
    InsiderMembershipMutated.unsubscribe(invalidationFn);
};
/** Auxiliary function to handle invalidation of the Insider membership information query on certain AppEvents. It saves the last callback subscribed and retailer token used to avoid having multible callbacks subscribed at the same time. */ var invalidateOnEvents = function() {
    var subscribedInvalidationCallback = null;
    var retailerToken = null;
    return function(invalidationCallback, token) {
        if (token !== retailerToken) {
            if (subscribedInvalidationCallback) {
                invalidateAppEvents(invalidationCallback);
            }
            InsiderMembershipMutated.subscribe(invalidationCallback);
            subscribedInvalidationCallback = invalidationCallback;
            retailerToken = token;
        }
    };
}();
